var _style, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCandidatePin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 30",
    style: {
      enableBackground: "new 0 0 20 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,10c0,5.5-10,19.4-10,19.4S0,15.5,0,10S4.5,0,10,0S20,4.5,20,10z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 10,
    cy: 7.2,
    r: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.7,9.7C17.7,5.5,14.2,2,10,2c-4.2,0-7.7,3.4-7.7,7.7c0,1.7,0.6,3.3,1.5,4.5l0,0l0,0 c1.4,1.9,3.6,3.1,6.2,3.1c2.3,0,4.5-1,5.9-2.8l0.3-0.3l0,0C17.1,12.9,17.7,11.3,17.7,9.7z M10,3.1c3.7,0,6.6,3,6.6,6.6 c0,1.4-0.4,2.7-1.1,3.7c-0.2-0.2-0.4-0.4-0.6-0.6c-3.1-2.6-7.6-2.3-10.4,0.6c-0.7-1.1-1.1-2.3-1.1-3.7C3.4,6,6.3,3.1,10,3.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidatePin);
export default __webpack_public_path__ + "static/media/candidate-pin.0eff634e.svg";
export { ForwardRef as ReactComponent };